import { useTranslation } from "react-i18next";
import {
  Avatar,
  Flex,
  Form,
  Layout,
  Space,
  TableColumnsType,
  TableProps,
  Typography,
  message
} from "antd";
import {
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";

import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { EyeOutlined } from "@ant-design/icons";

import { FormInstance } from "antd/lib";
import PageHeader from "../../components/page-header/PageHeader";
import TableData from "../../components/table-data/TableData";
import { routesConfig } from "../../config/routes";
import {
  getListCourseAttendance
} from "../../service/setting-attendance";
import FilterTable from "./filter-table/FilterTable";

type AutoScoringManagementProps = {
  title?: string;
};

const AutoScoringManagement = ({ title }: AutoScoringManagementProps) => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();

  const [accountReportCheckIn, setAccountReportCheckIn] = useState<any[]>([]);
  const [dataFilter, setDataFilter] = useState({
    course_name: "",
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");

  const [messageApi, contextHolder] = message.useMessage();

  const fetchData = async (searchParam: any) => {
    try {
      const response = await getListCourseAttendance(searchParam);
      const { data } = response.data;
      setAccountReportCheckIn(data.data);
      setTotalPage(data?.total?._count?.id);
      setLoading(false);
    } catch (error) { }
  };
  useEffect(() => {
    fetchData({
      course_name: searchValue,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
    });
  }, [pageSize, pageNumber]);

  const dataColumnsReportCheckIn: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Mã khoá học", "Mã khoá học"),
      dataIndex: "code",
      key: "code",
      width: 20,
    },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "name",
      key: "name",
      width: 25,
      render: (_: any, record) => {
        return (
          <Flex className="table-order-course-name">
            <img
              className=""
              loading="eager"
              alt=""
              src={record?.image || "/images/ic_school_placeholder.svg"}
            />
            <div className="pl-2">
              <span className="course-title">{record?.name}</span>
              {/* <span>{record?.diaChi}</span> */}
            </div>
          </Flex>
        );
      },
      sorter: {
        compare: (a, b) => a.name.length - b.name.length,
      },
    },
    {
      title: t("Người tạo", "Người tạo"),
      dataIndex: "fullName",
      key: "fullName",
      sorter: {
        compare: (a, b) =>
          a.mooc_course_plan?.auth_user?.first_name.length -
          b.mooc_course_plan?.auth_user?.last_name.length,
      },
      width: 20,
      render: (_, data: any) => {
        return (
          <Flex align="center">
            <Avatar style={{ backgroundColor: "#f56a00" }}>
              {data?.mooc_course_plan?.auth_user?.first_name.charAt(0)}
            </Avatar>
            <Typography.Text className="pl-2">
              {data?.mooc_course_plan?.auth_user?.first_name +
                " " +
                data?.mooc_course_plan?.auth_user?.last_name}
            </Typography.Text>
          </Flex>
        );
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };
        const onLink = () => {
          navigate(
            `/${routesConfig.scoringManagement}/${routesConfig.exercises}/${location?.id}`
          );
        };
        return (
          <Space>
            <Link
            className="action-table cursor-pointer"
            to={`${routesConfig.exercises}/${location?.id}`}
            state={{
              name: record.name,
            }}
          >
            <EyeOutlined />
          </Link>
          </Space>
        );
      },
      fixed: "right",
      width: 8,
    },
  ];

  const defaultCheckedList = dataColumnsReportCheckIn.map(
    (item) => item.key as string
  );

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const columnChecked = useMemo(() => {
    return dataColumnsReportCheckIn.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList]);

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = async (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      const searchParam = {
        ...dataFilter,
        take: 10,
        skip: 0,
        course_name: searchValue,
      };
      setPageNumber(1);
      fetchData(searchParam);
    }
  };

  const handleSubmitSearch = () => {
    const searchParam = {
      ...dataFilter,
      take: 10,
      skip: 0,
      course_name: searchValue,
    };
    setPageNumber(1);
    fetchData(searchParam);
  };

  const clearFilter = async (formInstance: FormInstance) => {
    setLoading(true);
    setDataFilter({
      course_name: "",
    });
    const searchParam = {
      ...dataFilter,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
      course_name: searchValue,
    };
    fetchData(searchParam);
    formInstance.resetFields();
  };

  const handleFinish = (values: any) => {
    setLoading(true);

    const searchParam = {
      ...values,
      take: pageSize,
      skip: (pageNumber - 1) * pageSize,
      course_name: searchValue,
    };
    fetchData(searchParam);
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter
  ) => { };

  return (
    <Layout className="page-header-group">
      {contextHolder}
      <Form.Provider>
        <div
          className={`page-header-group--layout ${showFilter ? "open-filter" : ""
            }`}
        >
          <div className="table-header--wrapper justify-between">
            <div className="table-header--left">
              <PageHeader title={title} />
            </div>
            <FilterTable
              searchValue={searchValue}
              dataColumns={dataColumnsReportCheckIn}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
            />
          </div>
        </div>
        <TableData
          dataTable={accountReportCheckIn}
          dataColumns={columnChecked}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalPage}
          handleTableChangeProps={handleTableChange}
        />
      </Form.Provider>
    </Layout>
  );
};

export default AutoScoringManagement;
